import { type ProductGroupItem } from '../../../shared/types';

// eslint-disable-next-line complexity
function sortActivityDuration(a: ProductGroupItem, b: ProductGroupItem): number {
    const durationDayA = a.activityDuration?.days;
    const durationHourA = a.activityDuration?.hours;
    const durationMinA = a.activityDuration?.minutes;
    const durationDayB = b.activityDuration?.days;
    const durationHourB = b.activityDuration?.hours;
    const durationMinB = b.activityDuration?.minutes;

    if (
        (!durationDayA && durationDayB) ||
        (durationDayA && durationDayB && durationDayA < durationDayB)
    ) {
        // days for a either don't exist or are smaller than days for b
        return -1;
    }

    if (
        (durationDayA && !durationDayB) ||
        (durationDayA && durationDayB && durationDayA > durationDayB)
    ) {
        // days for a either don't exist or are smaller than days for a
        return 1;
    }

    if (
        (!durationHourA && durationHourB) ||
        (durationHourA && durationHourB && durationHourA < durationHourB)
    ) {
        // hours for a either don't exist or are smaller than hours for b
        return -1;
    }

    if (
        (durationHourA && !durationHourB) ||
        (durationHourA && durationHourB && durationHourA > durationHourB)
    ) {
        // hours for b either don't exist or are smaller than hours for a
        return 1;
    }

    if (
        (!durationMinA && durationMinB) ||
        (durationMinA && durationMinB && durationMinA < durationMinB)
    ) {
        // minutes for a either don't exist or are smaller than hours for b
        return -1;
    }

    if (
        (durationMinA && !durationMinB) ||
        (durationMinA && durationMinB && durationMinA > durationMinB)
    ) {
        // minutes for b either don't exist or are smaller than hours for a
        return 1;
    }

    return 0;
}

const removeLastLetter = (value: string, amount: number): string => {
    return amount > 1 ? value : value.slice(0, value.length - 1);
};

export { removeLastLetter, sortActivityDuration };
